import { firebase } from 'commons/configs';
const storage = firebase.storage();

export const uploadImage = (storageRef, base64Str) => {
  return storage
    .ref(storageRef)
    .putString(base64Str, 'data_url')
    .then(() => storage.ref(storageRef).getDownloadURL());
};
